/**
* @Description: 语法学习-逆向记忆
* @author Wangshu
* @date 2020-05-27
*/
<template>
    <div class="reverse-wrap">
        <div class="left-title">
            <div>
                <img src="../../../../assets/img/grammarTest/book.png" alt="">
                <p>{{dataSource.curriculum_name}}</p>
            </div>
        </div>
        <div class="content-box">
            <transition name="el-fade-in-linear" mode="out-in">
                <!--强制复习的提示语-->
                <div class="hint-text" v-if="isHint" key="save">
                    <div>
                        <div class="hint-box">
                            <div>按照您的设置，接下来开始“逆向记忆”</div>
                            <div></div>
                        </div>
                    </div>
                    <div style="margin-top:30px;">
                        <el-button type="success" @click="beginStudy()">开始回忆</el-button>
                    </div>
                </div>
                <div class="answer-box" v-if="showWord">
                    <div class="word">
                        <div class="statement-text">
                        <span v-if="isAnswer">
                          {{exampleItem.name?exampleItem.name:'暂无数据'}}
                          <span
                            style="color:#000;font-size:26px;"
                          >{{exampleItem.phonetic_symbol}}<img class="volume" src="@/assets/img/grammarTest/volume.png" @click="playAudio" alt /></span>
                        </span>
                        <img v-else class="volume" src="@/assets/img/grammarTest/volume.png" @click="playAudio" alt />
                        <audio
                          v-if="exampleItem.voice"
                          id="eventAudio"
                          ref="sound"
                          class="sound"
                          :src="exampleItem.voice"
                          autoplay
                        ></audio>
                      </div>
                    </div>
                    <!--查看翻译提示框-->
                    <div class="example-box">
                        <div>{{exampleItem.meaning?exampleItem.meaning:'暂无数据'}}</div>
                        <div class="forget" @click="getAnswer">【忘记了】</div>
                    </div>
                    <!--弹窗下方按钮-->
                    <transition name="el-fade-in-linear" mode="out-in">
                        <!--下一个按钮-->
                        <div class="control-box" key="3">
                            <div @click="nextExample">
                                <img src="@/assets/img/grammarTest/circle_arrows.png" alt="">
                            </div>
                        </div>
                    </transition>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {getExample} from "@/api/grammar";
    import Lockr from 'lockr'
    import {mapState, mapGetters, mapMutations} from 'vuex';

    export default {
        name: "voiceDiscern",
        props: {
            reviewNum: {
                default: 0
            },//需要单词复习的个数
            dataSource: {
                default: {
                    studentId: 0,
                    reviewNum: 0,
                }
            },
        },
        computed: {},
        data() {
            return {
                isAnswer: false,
                isHint: true,//是否显示强制复习提示语
                showWord: false,//显示单词学习的内容
                grammarData: {},
                isCreated: false,
                exampleData: '',//例句数组
                exampleItem: {},//例句
                exampleIndex: 0,
            }
        },
        methods: {
            ...mapMutations(['CHANGE_STUDY_TYPE']),
            //触发发音
            playAudio() {
                let buttonAudio = document.getElementById('eventAudio');
                buttonAudio && buttonAudio.play()
            },
            // 获取强制复习单词
            getexampleData() {
                let params = {
                    token: Lockr.get('token'),
                    unit_id: this.dataSource.unit_id
                }
                getExample(params).then(res => {
                    this.exampleData = res.data
                    this.exampleItem = this.exampleData[0]
                })
            },
            //下一个例句
            nextExample() {
                this.isAnswer = false
                let arrLength = this.exampleData.length
                if (this.exampleIndex < arrLength - 1) {
                    this.exampleIndex++
                    this.exampleItem = this.exampleData[this.exampleIndex]
                } else {
                    //开启拼写阶段
                    let data = {
                        type: 'compel/spell',
                        dataSource: this.dataSource,
                        isStudyEnd: true,
                        closeBtn: true,
                    }
                    this.CHANGE_STUDY_TYPE(data)
                }
            },
            getAnswer() {
                this.isAnswer = true
            },
            //开始复习
            beginStudy() {
                this.isHint = false;
                this.showWord = true
            },
        },
        watch: {},
        mounted() {
            this.getexampleData()
        }
    }
</script>

<style scoped lang='less'>
.reverse-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  .left-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 10px 0 20px;
    height: 50px;
    color: #333;

    > div:nth-of-type(1) {
      display: flex;
      align-items: center;

      p {
        font-size: 18px;
      }

      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
  }

  .content-box {
    transition: all .5s;
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

    .hint-text {
      flex: 1;
            position: relative;
            text-align: center;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

      .hint-box {
        display: flex;
                flex-direction: column;
                justify-content: center;
                width: 600px;
                height: 160px;
                font-weight: bold;
                box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);

        > div:nth-of-type(2) {
          color: #ff626f;
          margin-top: 10px;
          font-size: 18px;
        }
      }

      > div:nth-of-type(2) {
        color: #ff626f;
        margin: 5px 0;
      }
    }

    .answer-box {
      flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 0 20px 20px 20px;

      .word {
        display: flex;
        width: 100%;
        > div:nth-of-type(1) {
          white-space: pre-wrap;
        }
      }

      .statement-text {
        font-size: 36px;
                font-weight: 600;
                margin: 10px 0;
                padding-right: 40px;
                color: #FF6601;
                display: flex;
                align-items: center;

        > div {
          display: inline-block;
        }

        .volume {
            cursor: pointer;
            width: 30px;
            height: 30px;
            object-fit: contain;
            margin: 0 10px;
            vertical-align: middle;
        }

        .volume:hover {
            opacity: 0.8;
        }
      }

      .sound-text {
        font-size: 24px;
        font-weight: 600;
        margin: 10px 0;
        padding-right: 40px;
        color: #666666;

        > span:nth-of-type(2) {
          > div:nth-of-type(1) {
            white-space: nowrap;
          }
        }

        > span:nth-of-type(2) {
          color: #ff6601;
        }
      }

      .amerism {
        font-size: 24px;

        > div:nth-of-type(1) {
          color: #333;
        }
      }

      .example-box {
        display: flex;
        align-items: center;
        flex: 1;
        background: #ffffff;
        box-shadow: 0px 1px 12px 3px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(223, 223, 223, 1);
        margin-top: 25px;
        position: relative;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 30px;
        box-sizing: border-box;
        width: 100%;

        .forget {
          position: absolute;
          bottom: 20px;
          right: 30px;
          font-size: 20px;
          color: #ff626f;
          cursor: pointer;
          transition: all 0.3s;
        }

        .forget:hover {
          color: #00bfcc;
        }
        > div:nth-of-type(1) {
          color: #000;
        }
      }
    }

    .control-box {
      display: flex;
      align-items: center;
      justify-content: center;

      > div {
        margin: 15px 20px;
        cursor: pointer;

        img {
          width: 50px;
          height: 50px;
        }
      }

      > div:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>